export default __webpack_public_path__ + "static/media/GE.657370fb.svg";